import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
	"inline-flex w-fit gap-1 h-6 items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-primary",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-primary/10 hover:bg-primary/20 text-black",
				secondary:
					"border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
				destructive:
					"border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
				outline: "text-foreground",

				// Badge Colors by Status
				pending: "border-transparent bg-yellow-500/10 hover:bg-yellow-500/20",

				"in-progress": "border-transparent bg-orange-500/10 hover:bg-orange-500/20",

				completed: "border-transparent bg-green-500/10 hover:bg-green-500/20",

				"on-hold": "border-transparent bg-gray-500/10 hover:bg-gray-500/20",

				cancelled: "border-transparent bg-red-500/10 hover:bg-red-500/20",

				overdue: "border-transparent bg-blue-500/10 hover:bg-blue-500/20"
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

const indicatorVariants = cva(
	"block size-2 rounded-full",
	{
		variants: {
			variant: {
				default: "bg-black",
				secondary: "",
				destructive: "",
				outline: "",

				pending: "bg-yellow-500",
				"in-progress": "bg-orange-500",
				completed: "bg-green-500",
				"on-hold": "bg-gray-400",
				cancelled: "bg-red-500",
				overdue: "bg-blue-500"
			}
		},
		defaultVariants: {
			variant: "default"
		}
	}
)

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
	VariantProps<typeof badgeVariants> {
	indicatorClassName?: string;
	showIndicator?: boolean;
}

function Badge({ className, variant, showIndicator = true, ...props }: BadgeProps) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props}>
			{showIndicator && (  // Condicionalmente mostrar el punto
				<span className={cn(indicatorVariants({ variant }), props.indicatorClassName)} />
			)}
			{props.children}
		</div>
	);
}

export { Badge, badgeVariants };
